import { memo, useCallback, useContext } from "react";
import { useModals } from "@mantine/modals";
import { useParams } from "react-router-dom";
import ActionCard from "src/components/ActionCard";
import VariantMetricDetail from "../VariantMetricDetail";
import { ProductContext } from "src/api/context/ProductContext";

type IVariantMetric = {
  isAllowWrite: boolean;
};

function VariantMetricList({ isAllowWrite }: IVariantMetric) {
  const { variantMetrics } = useContext(ProductContext);
  const modals = useModals();
  const { groupId } = useParams<{ groupId: string }>();

  const handleModal = useCallback(
    (variant = null) => {
      groupId &&
        modals.openModal({
          closeOnClickOutside: false,
          title: `${variant ? "Update" : "Add"} Variant Metric`,
          children: (
            <VariantMetricDetail
              variantArr={variantMetrics}
              variant={variant}
              isModal={true}
              groupId={groupId}
              isAllowWrite={isAllowWrite}
            />
          ),
        });
    },
    [groupId, variantMetrics, isAllowWrite]
  );

  return (
    <ActionCard
      title={"Variant Metrics"}
      mt={"md"}
      handleModal={isAllowWrite ? () => handleModal() : undefined}
      sx={{ minHeight: "16vh" }}
    >
      {variantMetrics?.map((e) => (
        <VariantMetricDetail
          key={e.id}
          variant={e}
          variantArr={variantMetrics}
          handleModal={handleModal}
          groupId={groupId}
          isAllowWrite={isAllowWrite}
        />
      ))}
    </ActionCard>
  );
}

export default memo(VariantMetricList);
